// Generated by ReScript, PLEASE EDIT WITH CARE

import * as I18n from "../../primitives/I18n.res.js";
import * as Stack from "../layout-and-structure/Stack.res.js";
import * as React from "react";
import * as FilePicker from "../../primitives/FilePicker.res.js";
import * as Stdlib_Array from "@rescript/runtime/lib/es6/Stdlib_Array.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as ReactDomElement from "../../primitives/ReactDomElement.res.js";
import * as Stylex from "@stylexjs/stylex";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as JsxRuntime from "react/jsx-runtime";
function DropZone(props) {
  let onError = props.onError;
  let onSuccess = props.onSuccess;
  let __disabled = props.disabled;
  let __maxSizeMb = props.maxSizeMb;
  let types = props.types;
  let customSubtitle = props.customSubtitle;
  let maxSizeMb = __maxSizeMb !== undefined ? __maxSizeMb : 1.0;
  let disabled = __disabled !== undefined ? __disabled : false;
  let match = React.useState(() => false);
  let setDragging = match[1];
  let dropZoneRef = React.useRef(null);
  let dropTargetRef = React.useRef(null);
  let disabledRef = React.useRef(disabled);
  let onDrop = React.useCallback(event => {
    let data = event.dataTransfer;
    let file = data.files[0];
    if (file !== undefined) {
      let file$1 = Primitive_option.valFromOption(file);
      let exit = 0;
      if (types !== undefined && FilePicker.isFileBadType(file$1, types) && FilePicker.isFileBadExtension(file$1, types)) {
        onError(FilePicker.messageFromError({
          TAG: "FileBadExtension",
          _0: types
        }));
      } else {
        exit = 1;
      }
      if (exit === 1) {
        if (file$1.size > maxSizeMb * 1048576) {
          onError(FilePicker.messageFromError("FileTooHeavy"));
        } else {
          onSuccess(file$1);
        }
      }
    } else {
      onError(FilePicker.messageFromError("FileNotFound"));
    }
    setDragging(param => false);
    event.preventDefault();
  }, []);
  let eventListenersHandler = React.useCallback((ref, listener) => {
    let eventsList = [["dragenter", event => {
      if (!disabledRef.current) {
        setDragging(param => true);
        dropTargetRef.current = event.target;
        return;
      }
    }], ["dragleave", event => {
      let currentElement = event.target;
      let refElement = Stdlib_Option.map(Primitive_option.fromNullable(dropTargetRef.current), prim => prim);
      if (Primitive_option.some(currentElement) === refElement) {
        return setDragging(param => false);
      }
    }], ["dragover", event => {
      event.preventDefault();
      event.stopPropagation();
    }], ["drop", event => {
      if (disabledRef.current) {
        event.preventDefault();
        return;
      } else {
        return onDrop(event);
      }
    }]];
    return Stdlib_Option.map(ReactDomElement.fromRef(ref), domElement => {
      eventsList.forEach(param => listener(domElement, param[0], param[1]));
    });
  }, []);
  React.useEffect(() => {
    eventListenersHandler(dropZoneRef, (prim0, prim1, prim2) => {
      prim0.addEventListener(prim1, prim2);
    });
    return () => {
      eventListenersHandler(dropZoneRef, (prim0, prim1, prim2) => {
        prim0.removeEventListener(prim1, prim2);
      });
    };
  }, []);
  React.useEffect(() => {
    disabledRef.current = disabled;
  }, [disabled]);
  let placeholderTypes = React.useMemo(() => {
    if (types !== undefined) {
      if (types.length !== 1) {
        return "(" + (Stdlib_Array.reduce(types, "", (acc, fileType) => acc + ((acc.length > 0 ? " " : "") + FilePicker.extensionFromType(fileType))) + ")");
      } else {
        return FilePicker.extensionFromType(types[0]);
      }
    } else {
      return "";
    }
  }, []);
  let tmp;
  if (match[0] && !disabled) {
    let newrecord = {
      ...{
        className: "backgroundColor-x81oyf2 borderColor-xkvjs7o borderStyle-xbsl7fq borderWidth-xmkeg23 alignItems-x6s0dn4 display-x78zum5 flexDirection-xdt5ytf",
        "data-style-src": "wino-gc:src/resources/selection-and-input/DropZone.res.js:15"
      }
    };
    let newrecord$1 = {
      ...{
        className: "paddingBlock-x1l8ay1m",
        "data-style-src": "wino-gc:src/resources/selection-and-input/DropZone.res.js:24"
      }
    };
    let newrecord$2 = {
      ...{
        className: "color-x1lewwgq font-xvf5sep letterSpacing-x1owzkzt textAlign-x2b8uid paddingBottom-xjkvuk6",
        "data-style-src": "wino-gc:src/resources/selection-and-input/DropZone.res.js:27"
      }
    };
    let newrecord$3 = {
      ...{
        className: "color-x1wohto9 font-x1qgc9lc letterSpacing-x1owzkzt textAlign-x2b8uid maxWidth-xaikfu8",
        "data-style-src": "wino-gc:src/resources/selection-and-input/DropZone.res.js:34"
      }
    };
    newrecord$1.children = JsxRuntime.jsxs(Stack.make, {
      children: [JsxRuntime.jsx("span", (newrecord$2.children = I18n.t("Drop your file in this area"), newrecord$2)), JsxRuntime.jsx("span", (newrecord$3.children = customSubtitle !== undefined ? customSubtitle : I18n.template(I18n.t("Import your {{types}} file by drag and dropping it in here."), {
        types: placeholderTypes
      }, undefined), newrecord$3))]
    });
    newrecord.children = JsxRuntime.jsx("div", newrecord$1);
    tmp = JsxRuntime.jsx("div", newrecord);
  } else {
    tmp = props.children;
  }
  return JsxRuntime.jsx("div", {
    children: tmp,
    ref: Primitive_option.some(dropZoneRef)
  });
}
let make = React.memo(DropZone);
export { make };
/* styles Not a pure module */